import CategoryToggleTab from "@/components/CategoryToggleTab";
import { EXTERIOR_CATEGORIES } from "@/lib/exteriorTemplates";
import { getGoal } from "@/lib/projectGoals";

export default function ExteriorTab({ project, onChange, costLibrary = null }) {
  const goal = getGoal(project?.project_goal);
  return (
    <CategoryToggleTab
      project={project}
      onChange={onChange}
      field="exterior"
      categories={EXTERIOR_CATEGORIES}
      title={goal.exterior.heading}
      description="Site-wide improvements independent of interior rooms. Toggle what applies, tune size and scope — costs roll into the dashboard."
      note={goal.exterior.note}
      totalTestId="exterior-grand-total"
      cardTestPrefix="ext"
      rateOverrides={costLibrary?.exterior_rates || null}
      currency={project?.currency || "USD"}
    />
  );
}
